import React from 'react';

const Logo = () => (
  <div className="logo-wrapper" style={{padding: "2rem 0"}}
>
    <span style={{fontSize: "3rem", color: "#0d0d0d"}}>{'Elohina '}</span>
    <span style={{fontSize: "3rem", color: "rgb(233, 189, 91)"}}>{'Guevara'}</span>
  </div>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js